import { Star, BadgeCheck } from "lucide-react";
import { Reveal, SectionHeader } from "./Shared";

const TESTIMONIALS = [
  {
    name: "Dato' Farhan Azman",
    location: "Kuala Lumpur, MY",
    tier: "VIP Member",
    quote:
      "The HSI and Syariah Bursa setups are impeccably timed. Reached my RM10k target on three consecutive setups last month alone.",
    gain: "+RM 42,800 Net Profit",
  },
  {
    name: "Marcus Tan",
    location: "Singapore",
    tier: "Premium Member",
    quote:
      "As an SGX and Nasdaq trader, having real-time signals delivered direct to my phone with exact entry and stop levels has changed my workflow completely.",
    gain: "+$18,400 USD Net",
  },
  {
    name: "Siti Nurhaliza R.",
    location: "Johor Bahru, MY",
    tier: "Essential Member",
    quote:
      "Started with RM15,000 capital on the Essential tier. The Syariah screening gives total peace of mind, and the RM300–500 targets are consistently hit.",
    gain: "+RM 8,200 Net",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Testimonials"
          title="Trusted from KL Sentral to Raffles Place."
          sub="Real members, verified desk records."
        />

        <div className="mt-14 grid gap-6 md:grid-cols-3 md:gap-8">
          {TESTIMONIALS.map((t, idx) => (
            <Reveal key={t.name} delay={idx * 0.12}>
              <figure
                data-testid={`testimonial-card-${idx}`}
                className="flex h-full flex-col rounded-2xl border border-line bg-surface p-7 transition-colors duration-300 hover:border-gold/40"
              >
                <div className="flex gap-1">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={15} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-300">“{t.quote}”</blockquote>
                <figcaption className="mt-6 border-t border-line pt-5">
                  <div className="flex items-center justify-between gap-3">
                    <div>
                      <p className="font-display text-sm font-bold text-slate-100">{t.name}</p>
                      <p className="font-mono text-[10px] text-slate-500">{t.location}</p>
                    </div>
                    <span className="rounded-full border border-alpha/40 bg-alpha/10 px-3 py-1 font-mono text-[10px] font-semibold text-alpha">
                      {t.tier}
                    </span>
                  </div>
                  <p className="mt-3 flex items-center gap-1.5 font-mono text-xs font-bold text-alpha">
                    <BadgeCheck size={14} /> {t.gain}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
